import React, { ReactNode } from "react"
import { useRouter } from "next/router"
import { getCustomerId } from "lib/filters"
import Loader from "@common/loader"
import useQuota from "components/quota/useQuota"
import EmptyState from "@common/emptyState"
import { getManageChannelsPageUrl } from "lib/navigation"
import EntitySelectorEmptyUnit from "components/entitySelectorEmptyUnit"
import { isHomePage, showEntitySelector } from "lib/util"
import { getPageKey } from "lib/navigation.js"
import { fetchEntityList } from "network/network"

// TODO - Bug: TaskEmptyState shows up on click of "Topics/Catalog" but sidenav menu vanishes.
export default function EmptyStateWrapper({ children }: { children: ReactNode }) {
  const router = useRouter()
  const { quota } = useQuota()
  const isPlan = quota?.plan_id != undefined
  const query = router?.query
  const selectedPageKey = getPageKey(router.asPath)
  const customerId = getCustomerId()
  const path = router.pathname

  const { data: entities } = fetchEntityList({
    customerId,
    count: 3,
    start: 0,
  })

  if (!quota) return <Loader />
  if (isHomePage(router.asPath)) return <> {children} </>

  if (
    path.indexOf("manage") != -1 &&
    path.indexOf("manage/topics") == -1 &&
    path.indexOf("manage/catalog") == -1
  )
    return <> {children} </>

  // for demo cases
  if (router.query.demo && router.query.demo == "true")
    return renderEntitySelectorOrChildren()

  // for enterprise
  if (!isPlan) return renderEntitySelectorOrChildren()

  // for everything else
  if (!entities) return <Loader />

  if (entities && Object.keys(entities).length == 0)
    return (
      <div className="h-screen flex items-center">
        <div className="m-auto text-center">
          <EmptyState
            illustration={
              <img
                className="h-80 w-80 text-center grayscale  "
                src="/images/process-machine.gif"
              />
            }
            title="Tasks in Progress"
            subTitle="If you've added sources for processing, you'll receive an email once it's completed."
            primaryActionBtnText="Create Data Source +"
            onPrimaryActionClick={() =>
              router.push(getManageChannelsPageUrl(router.asPath))
            }
          />
        </div>
      </div>
    )

  return renderEntitySelectorOrChildren()

  function renderEntitySelectorOrChildren() {
    const currentPageKey = getPageKey(router.asPath)
    if (showEntitySelector(query, selectedPageKey)) {
      return (
        <>
          <div className="h-full flex items-center">
            <EntitySelectorEmptyUnit useDefaultReport={currentPageKey == "stats"} />
          </div>
        </>
      )
    }
    return <>{children}</>
  }
}
